import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class DepartmentsService {
  fetchDepartments = () => {
    return fetch(config.config.endpointUrls.fetchDepartments(), {
      method: 'GET'
    })
  }
}

export default new DepartmentsService()



// WEBPACK FOOTER //
// ../src/services/departmentsService/departmentsService.js